export const CHAMPIONSHIP_TABS = ['Summary', 'Tournaments', 'Public site settings'];
